import type { ModuleTagEntry } from './index';

/** Modality LUT module tags. */
export const tags: ModuleTagEntry[] = [
  'RescaleIntercept',
  'RescaleSlope',
  'RescaleType',
];
